
import { Col, Form as BSForm, Row } from 'react-bootstrap';
import _ from 'lodash';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
export const ReportingStructureForm = ({ handleChange, handleBlur, values, errors, touched, initialized }) => {
  return (
    <div className="signite-form">
      <Row className="mb-3">
        <BSForm.Group as={Col}>
          <BSForm.Label>Reporting to</BSForm.Label>
          <BSForm.Control
            type="text"
            name="currentReportingTo"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.currentReportingTo}
            className={`form-control ${getErrorClass(errors, touched, 'currentReportingTo', initialized)}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'currentReportingTo', initialized)}</span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>No.of Reportees</BSForm.Label>
          <BSForm.Control
            type="number"
            name="currentNumberOfReportees"
            onChange={handleChange}
            onBlur={handleBlur}
            min={0}
            value={values.currentNumberOfReportees}
            className={`form-control ${getErrorClass(errors, touched, 'currentNumberOfReportees', initialized)}`}
          />
          <span className="errorMessage">
            {getErrorMessage(errors, touched, 'currentNumberOfReportees', initialized)}
          </span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>Team Size</BSForm.Label>
          <BSForm.Control
            type="number"
            name="currentTeamSize"
            onChange={handleChange}
            min={0}
            onBlur={handleBlur}
            value={values.currentTeamSize}
            className={`form-control ${getErrorClass(errors, touched, 'currentTeamSize', initialized)}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'currentTeamSize', initialized)}</span>
        </BSForm.Group>
      </Row>
    </div>
  );
};